import instance from "./ApiServices";
import authHeader from "./auth-header";

const getAll = () => {
  return instance.get("/users/", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/users/${id}`, { headers: authHeader() });
};

const getuser = (token) => {
  return instance.post("/auth/getuser", { token }, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/users/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/users/${id}`);
};

// eslint-disable-next-line import/no-anonymous-default-export

const UserService = {
  getAll,
  get,
  getuser,
  update,
  remove,
};

export default UserService;
